import { Button, Modal } from "antd";
import React, { Fragment } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { surveyListApi } from "../../../api/survey/surveyListApi";
import { SurveyContext } from "../../../store/surveyStore";

export default function Survey() {
  const history = useHistory();
  const { surveyC, dispatchSurvey } = SurveyContext();
  const [endedModal, setEndedModal] = useState();

  useEffect(() => {
    surveyListApi(dispatchSurvey);
  }, []);

  const btnName = (plrStatus, surveyStatus) =>
    surveyStatus === "LIVE"
      ? plrStatus.toLowerCase()
      : surveyStatus.toLowerCase();

  const handleSurveyBtn = (surveyID, surveyStatus, surveyName) => {
    dispatchSurvey({ type: "SURVEY_NAME", payload: surveyName });
    if (surveyStatus === "ENDED") {
      setEndedModal(true);
    } else {
      history.push(`/survey/${surveyID}`);
    }
  };

  return (
    <div className="survey-page">
      {surveyC.surveyList && (
        <div className="survey-lists">
          {surveyC.surveyList.map((surveyData, index) => {
            return (
              <Fragment key={index}>
                {surveyData.allow === "Y" && (
                  <div className="survey-list">
                    <div className="">
                      <h2>{surveyData.name}</h2>
                      <p>
                        {surveyData.detail} till {surveyData.end_date}
                      </p>
                    </div>
                    <button
                      className="custom-btn"
                      onClick={() =>
                        handleSurveyBtn(
                          surveyData.id,
                          surveyData.survey_status,
                          surveyData.name
                        )
                      }
                      >
                      {btnName(surveyData.plr_status, surveyData.survey_status)}
                    </button>
                  </div>
                )}
              </Fragment>
            );
          })}
        </div>
      )}
      <Modal
        visible={endedModal}
        className="sml-modal"
        onCancel={() => setEndedModal(false)}
        footer={
          <div className="sml-footer">
            <button
              className="custom-btn ok"
              onClick={() => setEndedModal(false)}
            >
              Ok
            </button>
          </div>
        }
      >
        <h2 style={{ textAlign: "center" }}>
          You can not participate now as survey has been ended
        </h2>
      </Modal>
    </div>
  );
}
